// Components
import VideoPlayer from '../video-player/VideoPlayer';

import { MEDIA } from '../../constants/media';

export default function Preview() {
  return (
    <section
      className="bg-green-700 py-8 flex justify-center px-4"
      id="preview">
      <div className="w-full h-full max-w-4xl bg-white rounded-xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-shadow">
        <h2 className="text-center text-2xl sm:text-3xl font-semibold mb-2">
          See availability all in one place
        </h2>
        <p className="text-gray-600 text-sm sm:text-base text-center max-w-2xl mx-auto mb-2">
          Participants mark when they’re free on the availability grid, making
          it simple to compare schedules and find the best time to meet.
        </p>
        <VideoPlayer
          src={MEDIA.preview0}
          className="w-full h-full bg-gray-100 rounded-lg border border-gray-200"
          showHoverPlay={false}
        />
      </div>
    </section>
  );
}
